import type { League } from '../../types'
import './ProfileLeagues.css'

export function RankChange({
  current,
  previous,
}: {
  current: number
  previous: number
}) {
  const diff = previous - current

  if (diff === 0) {
    return (
      <span className="profile__rank-change profile__rank-change--flat">–</span>
    )
  }

  const isUp = diff > 0
  return (
    <span
      className={`profile__rank-change ${
        isUp ? 'profile__rank-change--up' : 'profile__rank-change--down'
      }`}
    >
      {isUp ? '▲' : '▼'} {Math.abs(diff)}
    </span>
  )
}

/** The leagues you share with the player whose profile you are visiting, best rank first.
 *
 * Only the visited profile renders this — your own leagues live on the Leagues tab,
 * so a copy of them here was the same list one tap from itself. Shared leagues exist nowhere else,
 * and the set can legitimately be empty, hence the placeholder.
 *
 * Rows are static: the Leagues tab is where you open a league from. */
function ProfileLeagues({ leagues }: { leagues: League[] }) {
  return (
    <>
      <p className="profile__section-label label-plain">Leagues</p>
      <div className="profile__leagues">
        {leagues.length === 0 && (
          <div className="profile__empty-placeholder">
            <p>No shared leagues to show yet</p>
          </div>
        )}
        {[...leagues]
          .sort((a, b) => a.yourRank - b.yourRank)
          .map((league) => (
            <div key={league.id} className="profile__league-row">
              <span className="profile__league-name">{league.name}</span>
              <div className="profile__league-rank">
                <span>#{league.yourRank.toLocaleString()}</span>
                <RankChange
                  current={league.yourRank}
                  previous={league.previousRank}
                />
              </div>
            </div>
          ))}
      </div>
    </>
  )
}

export default ProfileLeagues
